module.exports = __webpack_public_path__ + "img/6_162.72408232.png";